import React, { useContext } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import Context from '../../../utils/context';
import styles from './index.module.css';
import { CloseIcon } from './guide_primitives';
import PatientGuide, { PATIENT_GUIDE_EYEBROW, PATIENT_GUIDE_INTRO, PATIENT_GUIDE_INTRO_SUB } from './mentee_guide';
import MentorGuide, { MENTOR_GUIDE_EYEBROW, MENTOR_GUIDE_INTRO, MENTOR_GUIDE_INTRO_SUB } from './mentor_guide';

function resolveReturnPath(search, isLoggedIn) {
  if (!isLoggedIn) {
    return '/member/login';
  }

  const params = new URLSearchParams(search);
  const returnTo = params.get('return_to');
  if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    return returnTo;
  }

  return '/member/conversations';
}

export default function PhoneCallsGuide() {
  const context = useContext(Context);
  const history = useHistory();
  const location = useLocation();

  const { role } = useParams();
  const isLoggedIn = context.auth.isLoggedIn();
  const isMentor = role === 'mentor';

  const eyebrow = isMentor ? MENTOR_GUIDE_EYEBROW : PATIENT_GUIDE_EYEBROW;
  const intro = isMentor ? MENTOR_GUIDE_INTRO : PATIENT_GUIDE_INTRO;
  const introSub = isMentor ? MENTOR_GUIDE_INTRO_SUB : PATIENT_GUIDE_INTRO_SUB;

  const handleClose = () => {
    history.push(resolveReturnPath(location.search, isLoggedIn));
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.header_inner}>
          <p className={styles.eyebrow_top}>{eyebrow}</p>
          <button type='button' className={styles.close_btn} onClick={handleClose} aria-label='Close'>
            <CloseIcon />
            <span className={styles.close_label}>Close</span>
          </button>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.content}>
          <div className={styles.intro}>
            <p className={styles.intro_eyebrow}>Your guide</p>
            <h2 className={styles.intro_title}>{intro}</h2>
            <p className={styles.intro_sub}>{introSub}</p>
          </div>

          <div className={styles.steps}>{isMentor ? <MentorGuide /> : <PatientGuide />}</div>

          <div className={styles.done_wrap}>
            <button type='button' className={styles.done_btn} onClick={handleClose}>
              Done
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
